export default __webpack_public_path__ + "static/media/v4play.70463590.png";